import styled from 'styled-components';

export const MpText = styled(`p`)<{ weight?: 'bold' | 'light'; size?: number }>`
	margin-bottom: 0;
	color: ${props => (props.weight === `light` ? `#8c8c8c` : `#000`)};
	white-space: pre-wrap;
	font-weight: ${props => (props.weight === `bold` ? `600` : 400)};

	font-size: ${props => props.size || `16`}px;
	line-height: 1.5em;

	@media (max-width: 575px) {
		font-size: 14px;
		line-height: 22px;
	}
`;
